import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ViewController, NavParams } from 'ionic-angular';

@Component({
    selector: 'modal-configure-geo',
    templateUrl: 'modal-configure-geo.html'
})
export class ModalConfigureGeoComponent {

    option: any = null;

    constructor(
        private viewCtrl: ViewController,
        private navParams: NavParams) {
        this.option = this.navParams.get("option");
    }

    onDismiss(option) {
        this.viewCtrl.dismiss(option);
    }

    onBackMenu() {
        this.onDismiss(this.option);
    }

    onSave() {
        this.option.applause = Boolean(this.option.applause);
        this.option.autoPause = Boolean(this.option.autoPause);
        this.option.placement = Boolean(this.option.placement);
        this.option.google = Boolean(this.option.google);
        this.onDismiss(this.option);
        console.log('this.option: ', this.option);
    }
}



// WEBPACK FOOTER //
// /src/components/modal-configure-geo/modal-configure-geo.ts